export class BlackHoleModal {
    static show(title = "이야기는 별이 되어...", message = "찾으시는 흔적은 은하수 너머로 홀연히 사라졌습니다.\n그곳엔 이제 고요한 공허만이 머물고 있네요.") {
        return new Promise((resolve) => {
            // 1. Overlay
            const overlay = document.createElement('div');
            overlay.className = 'fixed inset-0 bg-black z-[10002] flex items-center justify-center fade-in overflow-hidden';

            // 2. Cosmic Background (CSS generated stars)
            // 2. Cosmic Background (User requested @login.webp for consistency)
            const bg = document.createElement('div');
            bg.className = 'absolute inset-0 opacity-40 pointer-events-none bg-cover bg-center';
            bg.style.backgroundImage = 'url("/login.webp")';
            overlay.appendChild(bg);

            // Additional stars for depth if image is too static (optional, keeping minimal stars)
            const stars = document.createElement('div');
            stars.className = 'absolute inset-0 opacity-30 pointer-events-none';
            stars.style.backgroundImage = 'radial-gradient(white 1px, transparent 1px)';
            stars.style.backgroundSize = '50px 50px';
            overlay.appendChild(stars);

            // 3. Black Hole Effect
            const blackHole = document.createElement('div');
            blackHole.className = 'absolute w-[500px] h-[500px] rounded-full';
            blackHole.style.background = 'radial-gradient(circle at center, black 40%, #4c1d95 60%, transparent 70%)';
            blackHole.style.boxShadow = '0 0 100px 20px #8b5cf6';
            blackHole.style.animation = 'spin-slow 20s linear infinite';
            overlay.appendChild(blackHole);

            // Accretion Disk (Swirl)
            const disk = document.createElement('div');
            disk.className = 'absolute w-[600px] h-[600px] rounded-full border-[20px] border-l-fuchsia-600 border-t-transparent border-r-purple-600 border-b-transparent opacity-80 filter blur-xl';
            disk.style.animation = 'spin 3s linear infinite';
            overlay.appendChild(disk);

            // 4. Content Card
            // 4. Content Orb (Circular Glass)
            const card = document.createElement('div');
            // [UX] Animation: Slide Up + Float
            card.className = 'relative z-10 w-[420px] h-[420px] flex flex-col items-center justify-center bg-black/20 backdrop-blur-md border border-white/10 rounded-full p-8 text-center transform translate-y-10 opacity-0 transition-all duration-1000 ease-out delay-200 shadow-[0_0_50px_rgba(139,92,246,0.15)]';

            card.innerHTML = `
                <div class="mb-4 inline-flex p-3 rounded-full bg-white/5 ring-1 ring-white/20 shadow-[0_0_15px_rgba(255,255,255,0.1)]">
                    <span class="material-symbols-outlined text-3xl text-fuchsia-300 animate-pulse">auto_delete</span>
                </div>
                <h2 class="text-xl font-bold text-white mb-3 tracking-wide font-display">${title}</h2>
                <p class="text-zinc-300 leading-relaxed mb-6 font-light text-sm break-keep whitespace-pre-line px-4">${message}</p>
                
                <button id="btn-escape" class="px-8 py-3 bg-white/90 hover:bg-white text-black font-bold rounded-full hover:scale-105 active:scale-95 transition-all shadow-[0_0_20px_rgba(255,255,255,0.2)] hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] text-sm">
                     나의 궤도로 복귀
                </button>
            `;

            overlay.appendChild(card);
            document.body.appendChild(overlay);

            // Inject Styles if needed (spin-slow)
            if (!document.getElementById('black-hole-styles')) {
                const style = document.createElement('style');
                style.id = 'black-hole-styles';
                style.innerHTML = `
                    @keyframes spin-slow { 100% { transform: rotate(360deg); } }
                    @keyframes spin { 100% { transform: rotate(360deg); } }
                `;
                document.head.appendChild(style);
            }

            // Animation In
            requestAnimationFrame(() => {
                card.classList.remove('translate-y-10', 'opacity-0');
                card.classList.add('translate-y-0', 'opacity-100');
            });

            const close = () => {
                // [UX] Smooth Fade-out to Black per user request
                card.style.transform = 'scale(0.8) translateY(100px)';
                card.style.opacity = '0';

                // Overlay fade out
                overlay.style.transition = 'opacity 1.5s ease-out'; // Slower, dramatic fade
                overlay.style.opacity = '0';

                setTimeout(() => {
                    overlay.remove();
                    resolve();
                }, 1500);
            };

            const btn = card.querySelector('#btn-escape');
            btn.onclick = close;
        });
    }
}
